module.exports = __webpack_public_path__ + "static/media/del.fb6ad1bf.png";